export default {"src":"/_next/static/media/GreenTick.59ef5162.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};